import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/";
import { permissionsForRoute } from "../modules/dashboard/team/routePermissions";

/*
 * @@ Module router imports
 */

import AuthRouters from "../modules/auth/router";
import PublicRouters from "../modules/public/router";
import DashboardRouters from "../modules/dashboard/router";
import CheckoutRouters from "../modules/checkout/router";

Vue.use(VueRouter);

const routes = [
  // Pantalla pública de aceptación de invitación de equipo (multi-usuario)
  {
    path: "/invitacion",
    name: "team-invitation",
    component: () =>
      import("../modules/dashboard/team/pages/AcceptInvitation.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes: [
    ...routes,
    ...PublicRouters,
    ...AuthRouters,
    ...DashboardRouters,
    ...CheckoutRouters,
    ...[
      {
        path: "*",
        name: "404",
        component: () => import("../modules/404/NotFound")
      }
    ]
  ]
});

router.beforeEach((to, from, next) => {
  const isLogged = store.getters.isLogged;
  if (to.name === "home") next("/login");
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLogged) {
      // Multi-usuario: permisos por pantalla (meta.permission o el mapa de
      // routePermissions). Se cargan antes de decidir; si fallan no se
      // bloquea (el backend igual responde 403).
      const declared = to.matched
        .map(record => record.meta.permission)
        .filter(Boolean)
        .pop();
      const required =
        permissionsForRoute(to.name) || (declared ? [].concat(declared) : null);
      if (required) {
        const decide = () => {
          if (!store.getters.hasAnyPermission(required)) {
            if (from.name === "dashboard" || to.name === "dashboard")
              next(false);
            else next({ name: "dashboard" });
            Vue.prototype.$notifications &&
              Vue.prototype.$notifications.error({
                message: "No tienes permiso para ver esta sección"
              });
            return;
          }
          next();
        };
        if (store.getters.permissionsLoaded) {
          decide();
        } else {
          store.dispatch("loadMyPermissions").then(decide, decide);
        }
        return;
      }
      next();
      return;
    }
    next("/login");
  } else {
    if (to.name === "login" || to.name === "register") {
      if (isLogged) router.push({ name: "dashboard" });
    }
    next();
  }
});
export default router;
